// epoch(ms) ⇄ date input("YYYY-MM-DD")変換。保存は Time.DateInputToEpoch(ローカル 00:00)の epoch。
import Time from "./Time";

export function epochToDateInput(v: number | null): string {
  if (v == null) {
    return "";
  }
  return new Time(v).ToDateInput();
}

export function dateInputToEpoch(s: string): number | null {
  if (s === "") {
    return null;
  }
  return Time.DateInputToEpoch(s);
}
